import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import * as MemberService from '../../api/memberService';
import * as StampCardService from '../../api/stampCardService';

import useNavContext from '../../hooks/useNavContext';
import useStampCardContext from '../../hooks/useStampCardContext';
import useMerchantContext from '../../hooks/useMerchantContext';

import Spinner from '../../components/Spinner';

interface RouteParams {
  merchantId: string;
}

/**
 * Merchant
 */
export default function JoinMerchantScreen() {
  const selectedStampCard = useStampCardContext();
  const { merchantId } = useParams<RouteParams>();
  const selectedMerchant = useMerchantContext();

  const [isLoading, setIsLoading] = useState(true);
  const history = useHistory();

  const nav = useNavContext();

  useEffect(() => {
    const join = async (merchantId: string) => {
      if (isLoading) {
        try {
          const resMember = await MemberService.join(merchantId);

          if (resMember && selectedMerchant && selectedStampCard) {
            setTimeout(async () => {
              const resStampCard =
                await StampCardService.listByMerchantId(merchantId);

              if (resStampCard && resStampCard.length > 0) {
                selectedStampCard.setStampCard({
                  selectedStampCardId: resStampCard[0].id,
                  selectedSlotNumber: resStampCard[0].slotNumber,
                  selectedStampCampaignId: resStampCard[0].loyalty_campaign.id,
                });
                selectedMerchant.setMerchant({ merchantId: merchantId });
                setIsLoading(false);
              } else {
                selectedStampCard.setStampCard({
                  selectedStampCardId: '',
                  selectedSlotNumber: 0,
                  selectedStampCampaignId: '0',
                });
                selectedMerchant.setMerchant({ merchantId: merchantId });
                setIsLoading(false);
              }
            }, 1500);
          }
        } catch (e) {
          console.log('Error: joining merchant as member');
        }
      }
    };

    const checkMembership = async () => {
      if (merchantId && isLoading && selectedStampCard && selectedMerchant) {
        try {
          const resMember = await MemberService.get(merchantId);

          if (resMember) {
            const resStampCard =
              await StampCardService.listByMerchantId(merchantId);

            if (resStampCard) {
              if (resStampCard.length > 0) {
                selectedStampCard.setStampCard({
                  selectedStampCardId: resStampCard[0].id,
                  selectedSlotNumber: resStampCard[0].slotNumber,
                  selectedStampCampaignId: resStampCard[0].loyalty_campaign.id,
                });
                selectedMerchant.setMerchant({ merchantId: merchantId });
                setIsLoading(false);
                history.push(`/merchant`);
              } else {
                selectedStampCard.setStampCard({
                  selectedStampCardId: '',
                  selectedSlotNumber: 0,
                  selectedStampCampaignId: '0',
                });
                selectedMerchant.setMerchant({ merchantId: merchantId });
                setIsLoading(false);
                history.push(`/merchant`);
              }
            } else {
              selectedStampCard.setStampCard({
                selectedStampCardId: '',
                selectedSlotNumber: 0,
                selectedStampCampaignId: '0',
              });
              selectedMerchant.setMerchant({ merchantId: merchantId });
              setIsLoading(false);
              history.push(`/merchant`);
            }
          }
        } catch (e) {
          console.log('No membership');
          join(merchantId);
        }
      }
    };

    if (merchantId) {
      checkMembership();
    }
  }, [merchantId, history, isLoading, selectedStampCard, selectedMerchant]);

  useEffect(() => {
    if (!isLoading && nav) {
      history.push(`/merchant`);
      nav.setNav({
        menuNav: 'home',
      });
    }
  }, [
    isLoading,
    history,
    merchantId,
    selectedStampCard,
    selectedMerchant,
    nav,
  ]);
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 200,
      }}
    >
      <Spinner />
    </div>
  );
}
